import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { listGalleryImages } from '../../services/awsService';

const FeaturedProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Featured project metadata - titles and categories for the first 3 gallery images
    // TODO: Consider storing project metadata in a JSON file or DynamoDB for easier management
    const projectMeta = [
      { title: 'Modern Residential Build', category: 'New Construction', description: 'A contemporary residential home built with premium materials and modern design principles.' },
      { title: 'Home Renovation', category: 'Renovation', description: 'Complete renovation transforming a dated property into a modern, functional living space.' },
      { title: 'Custom Home Addition', category: 'Addition', description: 'Seamless home extension adding valuable living space while maintaining architectural harmony.' }
    ];

    const loadFeaturedProjects = async () => {
      console.log('[DEBUG FeaturedProjects] Loading featured projects from S3...');
      try {
        const images = await listGalleryImages();
        console.log('[DEBUG FeaturedProjects] Retrieved images from S3:', images.length);

        // Take the first 3 images as featured projects
        const featuredImages = images.slice(0, 3);

        // Transform images into project format with clean metadata
        const projectsData = featuredImages.map((image, index) => ({
          id: index + 1,
          title: projectMeta[index]?.title || `Project ${index + 1}`,
          description: projectMeta[index]?.description || 'Professional residential construction project completed with quality craftsmanship.',
          image: image.url,
          category: projectMeta[index]?.category || 'Residential'
        }));

        console.log('[DEBUG FeaturedProjects] Transformed projects:', projectsData);
        setProjects(projectsData);
      } catch (error) {
        console.error('[DEBUG FeaturedProjects] Error loading featured projects:', error);
        // TODO: Consider setting a fallback error state to display to user
      } finally {
        setLoading(false);
      }
    };

    loadFeaturedProjects();
  }, []);

  return (
    <section className="section">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="section-title mb-0">Featured Projects</h2>
        <Link to="/gallery" className="btn btn-outline-primary">View All Projects</Link>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading featured projects...</span>
          </Spinner>
        </div>
      ) : (
        <Row>
          {projects.map(project => (
            <Col md={4} className="mb-4" key={project.id}>
              <Card className="project-card border-0 shadow-sm h-100">
                <div className="overflow-hidden">
                  <Card.Img variant="top" src={project.image} alt={project.title} />
                </div>
                <Card.Body>
                  <div className="mb-2">
                    <span className="badge bg-primary">{project.category}</span>
                  </div>
                  <Card.Title>{project.title}</Card.Title>
                  <Card.Text className="text-muted">{project.description}</Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white border-0">
                  <Link to="/gallery" className="btn btn-sm btn-outline-primary">View Details</Link>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </section>
  );
};

export default FeaturedProjects;